export default "__VITE_ASSET__wG8oIZMt__"